import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveQuoteImportStatus } from "./index";

// Api's
import { quoteImportStatusApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getQuoteImportStatusSaga() {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(quoteImportStatusApi.getDomain);
		if (response.data.result) {
			yield put(saveQuoteImportStatus(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveQuoteImportStatus(null, true, resultError.messagesDataError));
		}
	}
}
